var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('h3',[_vm._v("Kit List")]),_vm._v(" "),_c('ul',{staticClass:"list-group"},_vm._l((_vm.kit),function(kitItem){return _c('li',{staticClass:"list-group-item text-left"},[_vm._v(_vm._s(kitItem.pivot.units)+" x "+_vm._s(kitItem.full_name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }